__turbopack_context__.v({
  "section": "index-module__8aFaza__section",
});
